import { useEffect, useState } from "react";

const slides = [
  {
    image:
      "https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?auto=format&fit=crop&w=900&q=80",
    alt: "Premium skincare product display",
    label: "Ayurveda inspired",
    title: "Modern clean actives",
  },
  {
    image:
      "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?auto=format&fit=crop&w=900&q=80",
    alt: "Kesar glow serum bottle",
    label: "Glow ritual",
    title: "Kesar Glow Serum",
  },
  {
    image:
      "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?auto=format&fit=crop&w=900&q=80",
    alt: "Moisturizer skincare jar",
    label: "Barrier care",
    title: "Haldi Chandan Cream",
  },
];

const stats = [
  { number: "12+", label: "Ayurvedic actives" },
  { number: "50K+", label: "Happy customers" },
  { number: "0%", label: "Harsh chemicals" },
  { number: "4.8/5", label: "Average rating" },
];

const Hero = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [isShopFormOpen, setIsShopFormOpen] = useState(false);

  const goTo = (n) => {
    setActiveSlide((n + slides.length) % slides.length);
  };

  const handleShopFormSubmit = (event) => {
    event.preventDefault();
    setIsShopFormOpen(false);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 3200);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setIsShopFormOpen(false);
      }
    };

    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, []);

  const currentSlide = slides[activeSlide];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=DM+Sans:wght@300;400;500&display=swap');

        :root {
          --gold: #2D7A5A;
          --gold-light: #F0F7F4;
          --gold-dark: #122E20;
          --cream: #F0F7F4;
          --ink: #122E20;
          --ink-soft: #385F4E;
          --border-gold: rgba(45,122,90,0.28);
        }

        .hero-section * { box-sizing: border-box; margin: 0; padding: 0; }

        .hero-section {
          background: var(--cream);
          font-family: 'DM Sans', sans-serif;
          position: relative;
          overflow: hidden;
        }

        .hero-bg-pattern {
          position: absolute; inset: 0; pointer-events: none;
          background-image:
            radial-gradient(circle at 15% 50%, rgba(125,189,156,0.24) 0%, transparent 50%),
            radial-gradient(circle at 85% 20%, rgba(45,122,90,0.16) 0%, transparent 40%);
        }

        .hero-grid-lines {
          position: absolute; inset: 0; pointer-events: none;
          background-image: repeating-linear-gradient(
            90deg,
            rgba(45,122,90,0.06) 0px, rgba(45,122,90,0.06) 1px,
            transparent 1px, transparent 80px
          );
        }

        .hero-inner {
          position: relative; z-index: 2;
          display: grid;
          grid-template-columns: 1fr 1fr;
          min-height: 580px;
        }

        .hero-left {
          padding: 56px 44px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 0;
          border-right: 0.5px solid var(--border-gold);
        }

        .eyebrow-row {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 20px;
          animation: fadeUp 0.6s 0.1s ease both;
        }

        .eyebrow-line {
          width: 28px; height: 1px;
          background: var(--gold);
          flex-shrink: 0;
        }

        .eyebrow-text {
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: var(--gold);
        }

        .hero-headline {
          font-family: 'Cormorant Garamond', serif;
          font-size: 58px;
          font-weight: 300;
          line-height: 1.08;
          color: var(--ink);
          margin-bottom: 18px;
          animation: fadeUp 0.6s 0.2s ease both;
        }

        .hero-headline em {
          font-style: italic;
          color: var(--gold-dark);
        }

        .hero-sub {
          font-size: 14px;
          font-weight: 300;
          color: var(--ink-soft);
          line-height: 1.75;
          max-width: 320px;
          margin-bottom: 28px;
          animation: fadeUp 0.6s 0.3s ease both;
        }

        .trust-row {
          display: flex;
          gap: 20px;
          margin-bottom: 36px;
          flex-wrap: wrap;
          animation: fadeUp 0.6s 0.4s ease both;
        }

        .trust-badge {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 11px;
          font-weight: 400;
          color: var(--ink-soft);
          letter-spacing: 0.02em;
        }

        .trust-dot {
          width: 4px; height: 4px;
          border-radius: 50%;
          background: var(--gold);
          flex-shrink: 0;
        }

        .hero-cta-row {
          display: flex;
          gap: 12px;
          align-items: center;
          animation: fadeUp 0.6s 0.5s ease both;
        }

        .btn-primary {
          background: var(--ink);
          color: var(--gold-light);
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          padding: 14px 30px;
          border: none;
          cursor: pointer;
          text-decoration: none;
          display: inline-block;
          transition: background 0.2s, color 0.2s;
        }

        .btn-primary:hover { background: var(--gold-dark); color: var(--cream); }

        .btn-secondary {
          background: transparent;
          color: var(--ink);
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          padding: 13px 24px;
          border: 0.5px solid var(--ink);
          cursor: pointer;
          text-decoration: none;
          display: inline-block;
          transition: border-color 0.2s, color 0.2s;
        }

        .btn-secondary:hover { border-color: var(--gold); color: var(--gold-dark); }

        .hero-right {
          position: relative;
          overflow: hidden;
          min-height: 580px;
        }

        .slide-img {
          position: absolute; inset: 0;
          width: 100%; height: 100%;
          object-fit: cover;
          opacity: 0;
          transition: opacity 0.9s ease;
        }

        .slide-img.active { opacity: 1; }

        .slide-overlay {
          position: absolute; inset: 0;
          background:
            linear-gradient(135deg, rgba(125,189,156,0.2) 0%, transparent 60%),
            linear-gradient(to top, rgba(18,46,32,0.5) 0%, transparent 50%);
          pointer-events: none;
        }

        .floating-card {
          position: absolute;
          bottom: 88px;
          left: 0;
          background: var(--cream);
          border-top: 2px solid var(--gold);
          padding: 14px 22px;
          min-width: 190px;
          animation: fadeUp 0.6s 0.65s ease both;
        }

        .floating-card-label {
          font-size: 10px;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: var(--gold);
          font-weight: 500;
          display: block;
          margin-bottom: 4px;
          transition: opacity 0.3s;
        }

        .floating-card-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 19px;
          font-weight: 400;
          color: var(--ink);
          display: block;
          transition: opacity 0.3s;
        }

        .slider-nav {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 16px;
          display: flex;
          flex-direction: column;
          gap: 8px;
          z-index: 10;
        }

        .nav-btn {
          width: 32px; height: 32px;
          background: rgba(250,246,238,0.88);
          border: 0.5px solid var(--border-gold);
          color: var(--ink);
          font-size: 14px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.2s, color 0.2s;
        }

        .nav-btn:hover { background: var(--gold); color: var(--cream); }

        .slider-dots {
          position: absolute;
          bottom: 20px;
          right: 16px;
          display: flex;
          gap: 6px;
          z-index: 10;
        }

        .dot-btn {
          height: 2px;
          width: 20px;
          background: rgba(45,122,90,0.3);
          border: none;
          cursor: pointer;
          padding: 0;
          transition: background 0.3s, width 0.3s;
        }

        .dot-btn.active { background: var(--gold); width: 36px; }

        .stats-strip {
          position: relative; z-index: 2;
          border-top: 0.5px solid var(--border-gold);
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          background: rgba(250,246,238,0.95);
          animation: fadeUp 0.6s 0.75s ease both;
        }

        .stat-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 3px;
          padding: 18px 16px;
          border-right: 0.5px solid var(--border-gold);
        }

        .stat-item:last-child { border-right: none; }

        .stat-number {
          font-family: 'Cormorant Garamond', serif;
          font-size: 24px;
          font-weight: 400;
          color: var(--gold-dark);
          line-height: 1;
        }

        .stat-label {
          font-size: 10px;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: var(--ink-soft);
          font-weight: 400;
          text-align: center;
        }

        .shop-modal-backdrop {
          position: fixed;
          inset: 0;
          z-index: 1000;
          background: rgba(18,46,32,0.58);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px;
        }

        .shop-modal {
          width: min(820px, 100%);
          background: var(--cream);
          display: grid;
          grid-template-columns: 0.9fr 1.1fr;
          border: 1px solid var(--border-gold);
          box-shadow: 0 26px 80px rgba(18,46,32,0.24);
          max-height: calc(100vh - 48px);
          overflow: auto;
        }

        .shop-modal-image {
          min-height: 460px;
          background:
            linear-gradient(to top, rgba(18,46,32,0.38), transparent 55%),
            url("https://images.unsplash.com/photo-1612817288484-6f916006741a?auto=format&fit=crop&w=800&q=80") center/cover;
          position: relative;
        }

        .shop-modal-image-caption {
          position: absolute;
          left: 24px;
          right: 24px;
          bottom: 24px;
          color: var(--cream);
          font-family: 'Cormorant Garamond', serif;
          font-size: 28px;
          line-height: 1.1;
        }

        .shop-modal-content {
          padding: 34px;
          position: relative;
        }

        .modal-close-btn {
          position: absolute;
          top: 14px;
          right: 14px;
          width: 34px;
          height: 34px;
          border: 0.5px solid var(--border-gold);
          background: transparent;
          color: var(--ink);
          cursor: pointer;
          font-size: 22px;
          line-height: 1;
        }

        .modal-close-btn:hover {
          background: var(--ink);
          color: var(--gold-light);
        }

        .shop-modal-kicker {
          color: var(--gold);
          font-size: 10px;
          font-weight: 500;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          margin-bottom: 10px;
        }

        .shop-modal-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 38px;
          font-weight: 300;
          line-height: 1.08;
          color: var(--ink);
          margin-bottom: 10px;
          padding-right: 30px;
        }

        .shop-modal-text {
          color: var(--ink-soft);
          font-size: 13px;
          line-height: 1.65;
          margin-bottom: 22px;
          max-width: 360px;
        }

        .shop-form {
          display: grid;
          gap: 14px;
        }

        .shop-form label {
          display: grid;
          gap: 7px;
          color: var(--ink-soft);
          font-size: 10px;
          font-weight: 500;
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }

        .shop-form input,
        .shop-form select,
        .shop-form textarea {
          width: 100%;
          border: 0.5px solid var(--border-gold);
          background: rgba(255,255,255,0.42);
          color: var(--ink);
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          padding: 12px 13px;
          outline: none;
        }

        .shop-form input:focus,
        .shop-form select:focus,
        .shop-form textarea:focus {
          border-color: var(--gold);
          box-shadow: 0 0 0 3px rgba(45,122,90,0.14);
        }

        .shop-form textarea {
          min-height: 86px;
          resize: vertical;
        }

        .shop-form-submit {
          margin-top: 4px;
          background: var(--ink);
          color: var(--gold-light);
          border: none;
          font-family: 'DM Sans', sans-serif;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          padding: 14px 22px;
          cursor: pointer;
        }

        .shop-form-submit:hover {
          background: var(--gold-dark);
          color: var(--cream);
        }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 768px) {
          .hero-inner { grid-template-columns: 1fr; }
          .hero-right { min-height: 320px; }
          .hero-left { padding: 40px 24px; border-right: none; border-bottom: 0.5px solid var(--border-gold); }
          .hero-headline { font-size: 40px; }
          .hero-cta-row { flex-wrap: wrap; }
          .shop-modal { grid-template-columns: 1fr; }
          .shop-modal-image { min-height: 210px; }
          .shop-modal-content { padding: 28px 22px 24px; }
          .shop-modal-title { font-size: 32px; }
          .stats-strip { grid-template-columns: repeat(2, 1fr); }
          .stat-item:nth-child(2) { border-right: none; }
          .stat-item:nth-child(3) { border-right: 0.5px solid var(--border-gold); }
          .stat-item:nth-child(3), .stat-item:nth-child(4) { border-top: 0.5px solid var(--border-gold); }
        }
      `}</style>

      <section className="hero-section" id="home">
        <div className="hero-bg-pattern" />
        <div className="hero-grid-lines" />

        <div className="hero-inner">
          <div className="hero-left">
            <div className="eyebrow-row">
              <span className="eyebrow-line" />
              <span className="eyebrow-text">Indian Skincare</span>
            </div>

            <h1 className="hero-headline">
              Glow Rooted
              <br />
              in <em>Rituals</em>
            </h1>

            <p className="hero-sub">
              Kesar, haldi, neem - ancient wisdom meets clean actives, blended
              for Indian skin and every season.
            </p>

            <div className="trust-row" aria-label="Store highlights">
              {["Dermat tested", "48h dispatch", "Clean actives"].map((t) => (
                <span className="trust-badge" key={t}>
                  <span className="trust-dot" />
                  {t}
                </span>
              ))}
            </div>

            <div className="hero-cta-row">
              <button
                className="btn-primary"
                onClick={() => setIsShopFormOpen(true)}
                type="button"
              >
                Shop Now
              </button>
              <a className="btn-secondary" href="#/shop">
                Explore Rituals
              </a>
            </div>
          </div>

          <div className="hero-right">
            {slides.map((slide, i) => (
              <img
                key={slide.image}
                src={slide.image}
                alt={slide.alt}
                className={`slide-img${activeSlide === i ? " active" : ""}`}
              />
            ))}

            <div className="slide-overlay" />

            <div className="floating-card">
              <span className="floating-card-label">{currentSlide.label}</span>
              <span className="floating-card-title">{currentSlide.title}</span>
            </div>

            <div className="slider-nav" aria-label="Slide navigation">
              <button
                className="nav-btn"
                aria-label="Previous slide"
                onClick={() => goTo(activeSlide - 1)}
                type="button"
              >
                ^
              </button>
              <button
                className="nav-btn"
                aria-label="Next slide"
                onClick={() => goTo(activeSlide + 1)}
                type="button"
              >
                v
              </button>
            </div>

            <div className="slider-dots">
              {slides.map((slide, i) => (
                <button
                  key={slide.title}
                  className={`dot-btn${activeSlide === i ? " active" : ""}`}
                  aria-label={`Show ${slide.title}`}
                  onClick={() => goTo(i)}
                  type="button"
                />
              ))}
            </div>
          </div>
        </div>

        <div className="stats-strip">
          {stats.map((s) => (
            <div className="stat-item" key={s.label}>
              <span className="stat-number">{s.number}</span>
              <span className="stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      </section>

      {isShopFormOpen && (
        <div
          className="shop-modal-backdrop"
          onClick={() => setIsShopFormOpen(false)}
          role="presentation"
        >
          <div
            aria-modal="true"
            className="shop-modal"
            onClick={(event) => event.stopPropagation()}
            role="dialog"
          >
            <div className="shop-modal-image">
              <span className="shop-modal-image-caption">
                Find your daily glow ritual
              </span>
            </div>

            <div className="shop-modal-content">
              <button
                aria-label="Close shop form"
                className="modal-close-btn"
                onClick={() => setIsShopFormOpen(false)}
                type="button"
              >
                x
              </button>

              <p className="shop-modal-kicker">Personalized skincare</p>
              <h2 className="shop-modal-title">Start with your skin goal</h2>
              <p className="shop-modal-text">
                Share a few details and we will help you choose the right
                Ayurvedic ritual for your skin.
              </p>

              <form className="shop-form" onSubmit={handleShopFormSubmit}>
                <label>
                  Full name
                  <input name="name" placeholder="Enter your name" type="text" />
                </label>

                <label>
                  Phone number
                  <input
                    name="phone"
                    placeholder="Enter your phone number"
                    type="tel"
                  />
                </label>

                <label>
                  Skin concern
                  <select defaultValue="" name="concern">
                    <option disabled value="">
                      Select concern
                    </option>
                    <option>Glow and dullness</option>
                    <option>Acne and marks</option>
                    <option>Dryness</option>
                    <option>Pigmentation</option>
                    <option>Sensitive skin</option>
                  </select>
                </label>

                <label>
                  Message
                  <textarea
                    name="message"
                    placeholder="Tell us what you are looking for"
                  />
                </label>

                <button className="shop-form-submit" type="submit">
                  Get Ritual Suggestion
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Hero;
